import * as React from 'react';
import { Link } from 'react-router-dom';
import { i18n } from '../../i18n';

export default () => (
  <div className='footer'>
    <Link
      className='button primary-button summary-button'
      to={{pathname: 'confirm'}}
    >
      {i18n.t('tool.summary.view_button_text')}
    </Link>
  </div>
);
